import {observer} from "mobx-react";
import {Alert, Button, Card} from "antd";
import React, {useEffect, useState} from 'react';
import {Bracket, Seed, SeedItem} from 'react-brackets';
import {pp} from "../../utils";
import Spacer from "../../components/Spacer";
import ScoreTag from "../../components/ScoreTag";
import {Switch2} from "../../components/Switcher";
import Device from "../../components/Device";

const MatchMV = observer(({m, tname}) => {
  let aWin = m.t1w || m.t2w;

  return <div>
    <Card size="small">
      <div className="space-y-2 text-left">
        <Spacer l={tname(m.t1_id)} r={aWin ? <ScoreTag v={m.t1w} type={m.t1w > m.t2w ? 'win' : 'lose'}/> : null} />
        <hr/>
        <Spacer l={tname(m.t2_id)} r={aWin ? <ScoreTag v={m.t2w} type={m.t2w > m.t1w ? 'win' : 'lose'}/> : null} />
      </div>
    </Card>
  </div>
});

const CustomSeed = ({seed, breakpoint, roundIndex, seedIndex}) => {
  return <Seed style={{ fontSize: 12, textAlign: 'left', width: Device.xs ? "250px" : "250px" }}>
    <SeedItem>
      <Switch2 v={seed.team}>
        <Card size="small">
          <div className="space-y-2">
            <Spacer l={seed.team} r="BYE" />
          </div>
        </Card>
        <MatchMV m={seed.match} tname={seed.tname}/>
      </Switch2>
    </SeedItem>
  </Seed>
};

const SimpleSeed = ({seed, breakpoint, roundIndex, seedIndex, onMatchClick}) => {
  let title = seed[0];
  let t1upcoming = seed[1].match(/Winner|Loser/);
  let t2upcoming = seed[2]?.match(/Winner|Loser/);
  let upcoming = t1upcoming || t2upcoming;
  let played = seed.length > 3 && _.isNumber(seed[3]);
  let t1win = played && seed[3] > seed[4];
  let t2win = played && seed[4] > seed[3];
  let mid = seed[5];

  return <Seed style={{ fontSize: 12, textAlign: 'left', width: Device.xs ? "250px" : "250px" }}>
    <SeedItem>
      <Switch2 v={title === "bye"}>
        <Card size="small">
          <Spacer l={seed[1]} r="BYE" />
        </Card>
        <div className={mid && (played || !upcoming) ? "cursor-pointer" : ""} onClick={() => mid && (played || !upcoming) && onMatchClick?.(mid)}>
          <Card size="small" title={title}>
            <div className="space-y-2">
              <Spacer l={seed[1]} r={played && <ScoreTag v={seed[3]} type={t1win ? 'win' : 'lose'}/>} style={{fontWeight: t1win && 'bold', color: t1upcoming ? '#bbb' : undefined}}/>
              <hr/>
              <Spacer l={seed[2]} r={played && <ScoreTag v={seed[4]} type={t2win ? 'win' : 'lose'}/>} style={{fontWeight: t2win && 'bold', color: t2upcoming ? '#bbb' : undefined}}/>
            </div>
          </Card>
        </div>
      </Switch2>
    </SeedItem>
  </Seed>
};

export const Knockout6 = observer(({division, teamById}) => {
  let rounds = [];
  let r = division.rounds[0];

  let tname = tid => teamById[tid].name;

  let ms2seeds = ms => ms.map(m => ({ match: m, tname, id: m.id }));

  if (division.rounds.length > 0) {
    rounds.push({
      title: 'Quarter Finals',
      seeds: [
        {
          id: r.bye_ids[0],
          team: tname(r.bye_ids[0]),
        },
        ...ms2seeds(r.matches),
        {
          id: r.bye_ids[1],
          team: tname(r.bye_ids[1]),
        },
      ],
    })
  }

  let bounce = gon.tournament.id === 21;
  let royal = gon.tournament.id === 56;

  let withCon = gon.tournament.id === 16;

  let consolation1;
  let consolation2;
  if (division.rounds.length > 1) {
    rounds.push({ title: "Semi Finals", seeds: ms2seeds(_.take(division.rounds[1].matches, 2))});

    // if (!bounce && !florida)
    //   consolation1 = [{ title: withCon ? "9/10 Place" : "5/6 Place", seeds: ms2seeds([division.rounds[1].matches[2]])}]
  }

  if (division.rounds.length > 2) {
    rounds.push({ title: !withCon ? "Finals" : "5/6 Place", seeds: ms2seeds([division.rounds[2].matches[0]])});

    // if (!florida)
      consolation2 = [{ title: !withCon ? "Bronze" : "7/8 Place", seeds: ms2seeds([division.rounds[2].matches[1]])}]
  }

  return <div className="overflow-x-auto min-h-screen">
    <MyBracket rounds={rounds} />
    <MyBracket rounds={consolation2} push={2}/>
    <MyBracket rounds={consolation1} push={1}/>
  </div>
})

const MyBracket = ({rounds, push}) => {
  if (!rounds)
    return null;

  return <div style={{marginLeft: push && ((push*250)+"px")}}>
    <Bracket rounds={rounds} renderSeedComponent={CustomSeed} mobileBreakpoint={0} />
  </div>
}

export const Knockout4with56 = observer(({division, teamById}) => {
  let rounds = [];

  let tname = tid => teamById[tid].name;

  let ms2seeds = ms => ms.map(m => ({ match: m, tname, id: m.id }));

  let consolation = [];
  let addon = [];
  let title;
  if (division.rounds.length > 0) {
    rounds.push({ title: "Semi Finals", seeds: ms2seeds(_.take(division.rounds[0].matches, 2))});
    addon.push({ title: "5/6 Place", seeds: ms2seeds([division.rounds[0].matches[2]])});
  }

  if (division.rounds.length > 1) {
    rounds.push({ title: "Finals", seeds: ms2seeds([division.rounds[1].matches[0]])});

    let title = division.kind === "playoff" ? "Bronze" : "7/8 places";
    consolation.push({ title, seeds: ms2seeds([division.rounds[1].matches[1]])});
  }

  return <div className="overflow-x-auto">
    <div>
      <MyBracket rounds={rounds}  />
      <MyBracket rounds={consolation} push={1} />
      <MyBracket rounds={addon} />
    </div>
  </div>
});

export const KnockoutFlex = observer(({lanes, onMatchClick}) => {
  const renderSeed = (props) => <SimpleSeed {...props} onMatchClick={onMatchClick} />;

  return <div className="overflow-x-auto">
    {!lanes?.length && <Alert message="Waiting for Prelims Results" type="warning" />}
    {!!lanes?.length && lanes.map((l, i) => {
      return <div key={i} className="">
        { l.lane && <div className="text-lg p-4">{l.lane}</div> }
        <div style={{marginLeft: l.push && ((l.push*250)+"px")}}>
          <Bracket rounds={l.brackets} renderSeedComponent={renderSeed} key={i} mobileBreakpoint={0}/>
        </div>
    </div>}
    )}
  </div>
})

export const Knockout4 = observer(({division, teamById}) => {
  let rounds = [];

  let tname = tid => teamById[tid].name;

  let ms2seeds = ms => ms.map(m => ({ match: m, tname, id: m.id }));

  let consolation;
  if (division.rounds.length > 0)
    rounds.push({ title: division.rounds[0].name, seeds: ms2seeds(division.rounds[0].matches)});

  if (division.rounds.length > 1) {
    rounds.push({ title: "Finals", seeds: ms2seeds([division.rounds[1].matches[0]])});

    let title = division.kind === "playoff" ? "Bronze" : "7/8 places";
    consolation = [{ title, seeds: ms2seeds([division.rounds[1].matches[1]])}]
  }

  return <div className="overflow-x-auto min-h-screen">
    <div>
      <MyBracket rounds={rounds} />
      <MyBracket rounds={consolation} push={1} />
    </div>
  </div>
})

export const Knockout5 = observer(({division, teamById}) => {
  let rounds = [];

  let tname = tid => teamById[tid].name;

  let ms2seeds = ms => ms.map(m => ({ match: m, tname, id: m.id }));

  let consolation;
  let ff;

  if (division.rounds.length > 0) {
    let m = division.rounds[0].matches[0];
    ff = [{ title: division.rounds[0].name, seeds: ms2seeds([m])}]
  }

  if (division.rounds.length > 1)
    rounds.push({ title: division.rounds[1].name, seeds: ms2seeds(division.rounds[1].matches)});

  if (division.rounds.length > 2) {
    rounds.push({ title: "Finals", seeds: ms2seeds([division.rounds[2].matches[0]])});

    let title = "Bronze";
    consolation = [{ title, seeds: ms2seeds([division.rounds[2].matches[1]])}]
  }

  return <div className="overflow-x-auto min-h-screen">
    <div>
      <MyBracket rounds={ff} />
      <MyBracket rounds={rounds} push={1} />
      <MyBracket rounds={consolation} push={2} />
    </div>
  </div>
})